import * as Types from '../../../../graphql-types'

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type getMarketplaceHeroQueryVariables = Types.Exact<{
  cname: Types.Scalars['String']
}>

export type getMarketplaceHeroQuery = {
  marketplaceByCname: {
    __typename: 'Marketplace'
    id: string
    name: string
    heroText: string | null
    heroTextSecondary: string | null
    heroImage: string | null
  }
}

export const getMarketplaceHeroDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMarketplaceHero' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cname' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketplaceByCname' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cname' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cname' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heroText' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroTextSecondary' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'heroImage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  getMarketplaceHeroQuery,
  getMarketplaceHeroQueryVariables
>
